import { OutboxStatusEnum } from '../../../platform/outbox/enums/outbox-status.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { DataDispatchChannelEnum } from '../../../shared/modules/data-dispatch/enums/data-dispatch-channel.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Notification log filters
 */
export class NotificationLogFilters extends ApiRequestFilters {
	/**
	 * User IDs
	 */
	users?: number[];

	/**
	 * Notification channel values
	 */
	channels?: DataDispatchChannelEnum[];

	/**
	 * Outbox item status values
	 */
	statuses?: OutboxStatusEnum[];

	/**
	 * Record category enum values
	 */
	subjects?: AppSubjectEnum[];
}
